import * as jsPDF from 'jspdf'
import * as canvg from 'canvg'

window.canvg = canvg;

export function makeReport(mapImage, logoImage, mitigationImage, preparednessImage, preventionImage, peName, participationCommitment, stats)
{
    var doc = new jsPDF();

    //Base font size for headers
    doc.setFontSize(18);

    //Top banner background
    doc.setDrawColor(0);
    doc.setFillColor(32,61,5);
    doc.rect(0, 0, 1000, 18, 'F'); 

    //Commitment banner background
    doc.setFillColor(204,217,191);
    doc.rect(0, 175, 1000, 12, 'F');

    //Actions Banner Background
    doc.rect(0, 215, 1000, 12, 'F'); 

    doc.setFillColor(255,255,255);
    doc.addImage(logoImage, 'JPEG', 190, 2, 12, 14, "logo", "NONE");

    //Top banner
    doc.setTextColor(255, 255, 255);
    doc.text(peName + ' Report', 5, 12);

    //Commitment banner 
    doc.setTextColor(31, 61, 5);
    doc.text('Commitment Summary', 5, 183);

    //Actions banner
    doc.text('Actions by Category', 5, 223);

    //Map
    doc.addImage(mapImage, 
    'JPEG', 
    5, 
    20,
    200, 150)



    //Commitment Body
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);

    doc.text('Participation Commitment:', 7, 195);
    doc.text('Projected Commitment:', 7, 200);
    doc.text('Confirmed Commitment:', 7, 205);
    doc.text('Total Approved Actions:', 7, 210);

    doc.text(participationCommitment.commitment, 75, 195);
    doc.text(participationCommitment.projected, 75, 200);
    doc.text(participationCommitment.confirmed, 75, 205);
    doc.text(participationCommitment.actions, 75, 210);


    //Actions body
    statsBlock(doc,5,230,"Mitigation", stats.mitigation,[143, 70, 162], "Acres Treated", mitigationImage)
    statsBlock(doc,75,230,"Preparedness", stats.preparedness,[203, 77, 21], "Actions Taken", preparednessImage)
    statsBlock(doc,145,230,"Prevention", stats.prevention,[31, 61, 5], "Actions Taken", preventionImage)

    return doc;
}

function statsBlock(doc, x, y, category, value, valueColor, units, icon)
{
    doc.setFillColor(255, 255, 255);
    doc.roundedRect(x, y, 60, 50, 3, 3, 'FD'); 
    
    doc.setFontStyle("bold");
    doc.setFontSize(16);
    doc.setTextColor(32, 61, 5);
    doc.text('Wildfire', x + 20, y+10);
    
    doc.text(category, x + 20, y+17);
    
    doc.addImage(icon, 'JPEG', x + 5, y + 5, 12, 16, "icon" + category, "NONE");

    doc.setLineWidth(0.25);
    doc.line(x+5, y+20, x+55, y+20);

    doc.setFontSize(30);

    doc.setTextColor(valueColor[0],valueColor[1],valueColor[2]);
    doc.text(value, (x+31) - (value.length * 2.75), y+35);


    doc.setFontStyle("normal");
    doc.setTextColor(0,0,0);
    doc.setFontSize(12);
    doc.text(units, x+18, y+45);
}

// var pc = { commitment : "$12,345"
// , projected : "$23,456"
// , confirmed : "$567"
// , actions : "2"
// };

// var stats = { mitigation : "$9,876,543"
// , preparedness : "5,325"
// , prevention : "23"
// }


// var doc = makeReport("data here",
// "Wasatch County",
// pc, stats
// )
